@if (resolveSpec$ | async; as spec) {
  <div class="layout-row">
    <!-- Type -->
    <mat-form-field>
      <elder-select
        appItemPropertyTypeSelect
        name="type"
        class="flex"
        required
        valueAsId
        [(value)]="spec.type"
      >
      </elder-select>
    </mat-form-field>
    <!-- Known Property -->
    @if (spec.type === ProductionListPropertyResolveType.KNOWN_PROPERTY) {
      <mat-form-field>
        <elder-select
          appKnownPropertySelect
          name="known-property"
          class="flex"
          required
          valueAsId
          [(value)]="spec.knownProperty"
        >
        </elder-select>
      </mat-form-field>
    }
    <!-- Property -->
    @if (showProperty()) {
      <mat-form-field>
        <elder-select
          class="flex"
          productKind
          appPropertySelect
          name="property"
          required
          valueAsId
          [(value)]="spec.propertyId"
        >
          <div *elderSelectValue="let value" class="layout-col">
            <span style="line-height: 20px">{{ value.description }}</span>
            <span class="mat-caption">{{ value.id }}</span>
          </div>
        </elder-select>
      </mat-form-field>
    }
    <!-- Attachment -->
    @if (spec.type === ProductionListPropertyResolveType.ATTACHMENT) {
      <app-attachment-spec-detail class="flex" [attachment]="spec.attachment">
      </app-attachment-spec-detail>
    }
    <!-- Action -->
    @if (showAction()) {
      <mat-form-field>
        <elder-select
          appActionSelect
          name="action"
          placeholder="{{ 'process.actions.action' | translate }}"
          allowNull
          valueAsId
          [(value)]="spec.action"
        >
          <div *elderSelectValue="let value" class="layout-col">
            <span style="line-height: 20px">{{ value.name }}</span>
            <span class="mat-caption">{{ value.id }}</span>
          </div>
        </elder-select>
      </mat-form-field>
    }
  </div>
}
